import { useTranslation } from 'react-i18next'
import { formatMonetaryAmount } from '@/utils/numbers.utils'
import { Card, CardContent } from '@/components/ui/card'
import { MemberStatsProps } from './types'
import { CurrencyAmount } from '@/components/ui/CurrencyAmount'

export function MemberStats({
  lifetimeSpend,
  lifetimeTip,
  currency
}: MemberStatsProps) {
  const { t } = useTranslation()

  return (
    <Card className="border-none shadow-none pt-0 px-0">
      <CardContent className="px-0">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-muted-foreground">
              {t('customers.lifetimeSpend')}
            </div>

            <div className="text-md font-semibold">
              <CurrencyAmount
                amount={formatMonetaryAmount(lifetimeSpend)}
                currency={currency}
              />
            </div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground">
              {t('customers.lifetimeTip')}
            </div>

            <div className="text-md font-semibold">
              <CurrencyAmount
                amount={formatMonetaryAmount(lifetimeTip)}
                currency={currency}
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
} 